import { render, staticRenderFns } from "./countdown321.vue?vue&type=template&id=24cb0438&scoped=true"
import script from "./countdown321.vue?vue&type=script&lang=js"
export * from "./countdown321.vue?vue&type=script&lang=js"
import style0 from "./countdown321.vue?vue&type=style&index=0&id=24cb0438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cb0438",
  null
  
)

export default component.exports